import React from 'react';

// Price-position filter as colored toggle chips (same colors/labels as the
// status column chip). Ordered expensive -> cheap. Multi-select toggle.
const LEVELS = [
  { value: 'highest',    key: 'product.myprice_highest',    cls: 'pux-chip-red' },
  { value: 'avg_higher', key: 'product.myprice_avg_higher', cls: 'pux-chip-orange' },
  { value: 'average',    key: 'product.myprice_average',    cls: 'pux-chip-yellow' },
  { value: 'avg_lower',  key: 'product.myprice_avg_lower',  cls: 'pux-chip-cyan' },
  { value: 'same',       key: 'product.myprice_same',       cls: 'pux-chip-blue' },
  { value: 'lowest',     key: 'product.myprice_lowest',     cls: 'pux-chip-green' },
];

export default function MyPriceChips({ t, value, onChange }) {
  const selected = value || [];
  const toggle = (v) => onChange(selected.includes(v) ? selected.filter(x => x !== v) : [...selected, v]);
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
      {LEVELS.map(l => {
        const on = selected.includes(l.value);
        return (
          <button key={l.value} type="button"
                  className={`pux-chip pux-chip-toggle ${on ? l.cls : 'off'}`}
                  onClick={() => toggle(l.value)}>
            {t(l.key)}
          </button>
        );
      })}
    </div>
  );
}
